import dagre from '@dagrejs/dagre';
import type { Node, Edge } from '@xyflow/react';
import type { HierarchyRankDirection, NodePosition } from './layout-types';

const DEFAULT_NODE_WIDTH = 180;
const DEFAULT_NODE_HEIGHT = 80;

export function getHierarchyLayout({
  nodes,
  edges,
  nodesep,
  ranksep,
  rankdir,
}: {
  nodes: Node[];
  edges: Edge[];
  nodesep: number;
  ranksep: number;
  rankdir: HierarchyRankDirection;
}) {
  const graph = new dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));

  graph.setGraph({ rankdir, nodesep, ranksep });

  nodes.forEach((node) => {
    graph.setNode(node.id, {
      width: node.measured?.width ?? DEFAULT_NODE_WIDTH,
      height: node.measured?.height ?? DEFAULT_NODE_HEIGHT,
    });
  });

  edges.forEach((edge) => {
    graph.setEdge(edge.source, edge.target);
  });

  dagre.layout(graph);

  const computedLayout = new Map<string, NodePosition>();

  for (const node of nodes) {
    const pos = graph.node(node.id);
    const width = node.measured?.width ?? DEFAULT_NODE_WIDTH;
    const height = node.measured?.height ?? DEFAULT_NODE_HEIGHT;

    computedLayout.set(node.id, {
      x: pos.x - width / 2,
      y: pos.y - height / 2,
    });
  }

  return computedLayout;
}
